import React, { useState } from "react";
import {
  Stack,
  Heading,
  Button,
  Text,
  ButtonGroup,
  useDisclosure,
  Flex,
  FormControl
} from "@chakra-ui/react";


import Layout from "./Layout";
import { ModalBox, View } from "@components";
import { IconTriangle } from "@assets/Icons";
import { t } from "@lang/i18n";

const LandingScreen = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    // const modalType = "both"

  return (
    <Layout menuType="company" isNavBarVisible>
      <Stack mx="auto" w="500px">
        <Heading as="h1" size="xl">
          Landing Page Screen
        </Heading>

    

        <Button onClick={onOpen}>Open Modal</Button>
              

        {/* Confirm purchase */}
        {/* <View>
                    <ModalBox isOpen={isOpen} onClose={onClose}>
                        <Text textColor="text.bold" textAlign="center" fontSize="20px" fontWeight="600">
                            Confirmation
                        </Text>

                        <Heading as="h3" fontSize="86px" fontWeight="700" mb="16px" textShadow="4px 4px 20px rgba(0, 0, 0, 0.25)"> 40€ </Heading>

                        <Text textColor="text.bold" textAlign="center" fontSize="14px" fontWeight="400">
                            Confirmez-vous la publication de cette annonce et le paiement de ce montant ?
                        </Text>

                        <ButtonGroup spacing="6" mt="30px">
                            <Button bg="notifs.error" borderRadius="24px" textColor="#fff" w="164px" h="40px"
                                    _hover={{ opacity: ".85" }}
                                    onClick={onClose}>
                                Annuler
                            </Button>
                            <Button bg="accent.candidate.main" borderRadius="24px" textColor="#fff" w="164px" h="40px"
                                _hover={{ bg: "accent.candidate.hover"}}
                                onClick={onClose}>
                                Confirmer
                            </Button>
                        </ButtonGroup>
                    </ModalBox>
                </View> */}

        {/* postuler */}
        {/* <View>
                    <ModalBox isOpen={isOpen} onClose={onClose}>
                        <Heading as="h3" fontSize="20px" fontWeight="600" mb="16px"> Postuler </Heading>
                        <Text textColor={COLORS.text.bold} textAlign="center" fontSize="16px" fontWeight="400">
                            Confirmez-vous la postulation sur cette annonce ?
                        </Text>

                        <ButtonGroup spacing="6" mt="30px">
                            <Button bg="notifs.error" borderRadius="24px" textColor="#fff" w="164px" h="40px"
                                    _hover={{ opacity: ".85" }}
                                    onClick={onClose}>
                                Annuler
                            </Button>
                            <Button bg="accent.candidate.main" borderRadius="24px" textColor="#fff" w="164px" h="40px"
                                _hover={{ bg: "accent.candidate.hover"}}
                                onClick={onClose}>
                                Confirmer
                            </Button>
                        </ButtonGroup>
                    </ModalBox>
                </View> */}
      </Stack>
    </Layout>
  );
};

export default LandingScreen;
